import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Bulk price report is a standalone app running outside DMS with a single (production)
 * instance, so every DMS environment links to it and only the tenant differs.
 */
const BULK_PRICE_REPORT_BASE_URL = 'https://bulk-price-report.omnetic.com/';

/**
 * Sidebar items need an in-app path even when the click is handled by an action.
 * This path has no route on purpose – it only keeps the item from sharing (and
 * highlighting) the active state of another menu item.
 */
export const BULK_PRICE_REPORT_MENU_PATH = '/bulk-price-report';

export function getBulkPriceReportUrl(tenantId: string | Nullish): string | null {
  if (isNil(tenantId)) {
    return null;
  }

  const url = new URL(BULK_PRICE_REPORT_BASE_URL);
  url.searchParams.set('tenant', tenantId);

  return url.toString();
}
